// extracted by mini-css-extract-plugin
module.exports = {"Map":"maper_Map__CiGlG","MapFluid":"maper_MapFluid__mgRqq","MapBlock":"maper_MapBlock__bbJv6","Link":"maper_Link__1Aq43"};